import axios, { AxiosError } from 'axios'
import config from 'config'

import { OctaneLogger } from '../../integrations/datadog/OctaneLogger'
import { defaultLosJsonHeaders } from '../requestHeaders'

export default async function getInvitations() {
    try {
        const { data } = await axios.get(
            `${config.API_BASE_URL}/api/v3/user_invitation/`,
            {
                withCredentials: true,
                headers: defaultLosJsonHeaders(),
            },
        )

        return data
    } catch (error) {
        const axiosError = error as AxiosError

        OctaneLogger.axiosError(
            `Failed to get invitation: ${axiosError.message}`,
            axiosError,
        )

        throw axiosError
    }
}
